import {
  FeatureName,
  PermissionValues as Permissions,
  WorkspaceType,
} from '@gripp/shared-logic';
import { HomeDashboardPage } from './components/homeDashboardPage';

export const homeDashboardPaths = {
  root: 'home',
} as const;

export const homeDashboardRoutes = [
  {
    path: `${homeDashboardPaths.root}/*`,
    element: <HomeDashboardPage />,
    handle: {
      header: {
        titleKey: 'home.page.title',
        icon: 'map',
      },
      // ProtectedRoute enforces ONLY `requiredPermission`. The feature flag and
      // workspace-type are enforced page-side by HomeDashboardPage's self-guard,
      // which now serves BOTH branches (OEM → OEM dashboard, Producer → Pulse).
      // `requiredFeature` / `requiredWorkspaceType` below are NOT read by the
      // route guard — they are documentation-only. They retain the OEM values
      // for historical parity; the route admits any workspace type and the page
      // decides (OemHomeDashboard+OEM, PulseHomeDashboard+Producer, else bounce).
      requiredPermission: Permissions.activity.read,
      requiredWorkspaceType: WorkspaceType.Oem,
      requiredFeature: FeatureName.OemHomeDashboard,
    },
  },
];
